// Title row used by every workspace page.
const PageHeader = ({ title, intro, actions, testId }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4" data-testid={testId}>
    <div className="min-w-0">
      <h2 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">{title}</h2>
      {intro && <p className="mt-2 max-w-2xl text-sm text-slate-400">{intro}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const ghostBtn = "flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono text-[10px] tracking-[0.2em] uppercase text-slate-300 transition-colors hover:border-vortex-cyan/60 hover:text-vortex-cyan disabled:opacity-50";
export const card = "border border-white/10 bg-vortex-surface/60";

export default PageHeader;
